
























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GBrandTopHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    isInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    onClick: {
      type: Function as PropType<Function>,
    },
  },
});
